import { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

type CheckCircleProps = IllustrationProps & {
  color?: string;
};

const CheckCircle: FC<CheckCircleProps> = (allProps) => {
  const { svgProps: props, color = "#C4CBD5", ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="CheckCircle"
      illustration={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={restProps.width ?? "49"}
          height={restProps.height ?? "48"}
          viewBox="0 0 49 48"
          fill="none"
          {...props}
        >
          <g clipPath="url(#clip0_5503_24872)">
            <path
              d="M24.187 4.5C20.3303 4.5 16.5602 5.64366 13.3534 7.78634C10.1466 9.92903 7.64728 12.9745 6.17137 16.5377C4.69546 20.1008 4.3093 24.0216 5.06171 27.8043C5.81412 31.5869 7.67131 35.0615 10.3984 37.7886C13.1256 40.5157 16.6001 42.3729 20.3828 43.1253C24.1654 43.8777 28.0862 43.4916 31.6493 42.0157C35.2125 40.5397 38.258 38.0404 40.4007 34.8336C42.5434 31.6269 43.687 27.8567 43.687 24C43.6816 18.83 41.6254 13.8732 37.9696 10.2174C34.3138 6.56167 29.3571 4.50546 24.187 4.5ZM32.7483 20.5613L22.2483 31.0613C22.109 31.2007 21.9435 31.3114 21.7614 31.3868C21.5793 31.4623 21.3841 31.5012 21.187 31.5012C20.9899 31.5012 20.7947 31.4623 20.6126 31.3868C20.4305 31.3114 20.2651 31.2007 20.1258 31.0613L15.6258 26.5613C15.3443 26.2798 15.1862 25.898 15.1862 25.5C15.1862 25.102 15.3443 24.7202 15.6258 24.4388C15.9072 24.1573 16.289 23.9992 16.687 23.9992C17.0851 23.9992 17.4668 24.1573 17.7483 24.4388L21.187 27.8794L30.6258 18.4388C30.7651 18.2994 30.9306 18.1888 31.1127 18.1134C31.2948 18.038 31.4899 17.9992 31.687 17.9992C31.8841 17.9992 32.0793 18.038 32.2614 18.1134C32.4435 18.1888 32.6089 18.2994 32.7483 18.4388C32.8876 18.5781 32.9982 18.7436 33.0736 18.9257C33.149 19.1077 33.1879 19.3029 33.1879 19.5C33.1879 19.6971 33.149 19.8923 33.0736 20.0743C32.9982 20.2564 32.8876 20.4219 32.7483 20.5613Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0_5503_24872">
              <rect
                width="48"
                height="48"
                fill="white"
                transform="translate(0.187012)"
              />
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};

export default CheckCircle;
